import { render, staticRenderFns } from "./FloatQrcode.vue?vue&type=template&id=8523b1c4&scoped=true"
import script from "./FloatQrcode.vue?vue&type=script&lang=js"
export * from "./FloatQrcode.vue?vue&type=script&lang=js"
import style0 from "./FloatQrcode.vue?vue&type=style&index=0&id=8523b1c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8523b1c4",
  null
  
)

export default component.exports